import script from "./AuthRoleOption.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthRoleOption.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__